export function truncateSummary(summary: string) : string {
  if(!summary)
    return null
  
  return summary.substr(0, Math.min(170, summary.lastIndexOf(" "))) + "..."
}


// WEBPACK FOOTER //
// ./src/app/tradingstudio/services/summary.service.ts